import {qsa, createElement} from "../utils/domUtils";
import axios from "axios";
import Chart from 'chart.js/auto'

const DEFAULT_SETTINGS = {
    type: 'pie',
    options: {
        responsive: true,
        maintainAspectRatio: false,
        responsiveAnimationDuration: 500,
        cutoutPercentage: 60,
        // legend: { display: true },
        plugins: {
            legend: {
                position: 'top'
            },
            title: {
                display: true,
                text: '',
                font: {
                    size: 18
                }
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let label = context.label,
                            value = context.formattedValue
                        return  ' ' + label + ' : ' + value;
                    }
                },
                // Updated default tooltip UI
                shadowOffsetX: 1,
                shadowOffsetY: 1,
                shadowBlur: 8,
                shadowColor: tooltipShadow,
                backgroundColor: window.colors.solid.white,
                titleColor: window.colors.solid.black,
                bodyColor: window.colors.solid.black
            }
        },
    },
};

const primaryColorShade = '#836AF9',
    yellowColor = '#ffe800',
    successColorShade = '#28dac6',
    warningColorShade = '#ffe802',
    warningLightColor = '#FDAC34',
    infoColorShade = '#299AFF',
    greyColor = '#4F5D70',
    blueColor = '#2c9aff',
    blueLightColor = '#84D0FF',
    greyLightColor = '#EDF1F4',
    tooltipShadow = 'rgba(0, 0, 0, 0.25)',
    lineChartPrimary = '#666ee8',
    lineChartDanger = '#ff4961',
    labelColor = '#6e6b7b',
    grid_line_color = 'rgba(200, 200, 200, 0.2)'; // RGBA color helps in dark layout

const initCharts = () => {
    qsa('.chartjs')
        .forEach((chartElement) => {
            initSingleChart(chartElement)
        });
}

const initSingleChart = async (canvasElement) => {
    // Wrap charts with div of height according to their data-height
    $(canvasElement).wrap($('<div style="height:' + canvasElement.getAttribute('data-height') + 'px"></div>'));
    let chartDataGetUrl = new URL(canvasElement.dataset.dataSource);
    let data = await axios.get(chartDataGetUrl)
        .catch((error) => {
        });
    if (!data){
        return;
    }

    let chartData = data?.data?.data;
    if (!chartData){
        return;
    }

    // Clone object
    let chartConfig = JSON.parse(JSON.stringify(DEFAULT_SETTINGS));
    chartConfig.data = canvasElement.id;

    let colors = generateColorsForData(chartData.labels.length);

    chartConfig.data = {
        datasets: [
            {
                labels: chartData.labels,
                data: chartData.values,
                backgroundColor: colors,
                borderWidth: 0,
                pointStyle: 'circle'
            }
        ],
        labels: chartData.labels,
    }

    chartConfig.options.plugins.title.text = chartData.title;

    let chart = new Chart(canvasElement, chartConfig);
}

const generateColorsForData = (labelsCount) => {
    const circleRadius = 360;
    let colors = [];
    for (let i = 0; i < labelsCount; i++) {
        let labelHue = (circleRadius/labelsCount)*i;
        colors.push(`hsl(${labelHue}, 90%, 60%)`)
    }
    return colors;
}

export default initCharts;
